import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_instancercv49ep9xa3t as Companion_instance } from './ActionPipe.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ActionCannonClass;
function ActionCannon() {
  if (ActionCannonClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ActionCannon', VOID, VOID, VOID, [1]);
    ActionCannonClass = $;
  }
  return ActionCannonClass;
}
var DispatcherPipeCannonClass;
function DispatcherPipeCannon() {
  if (DispatcherPipeCannonClass === VOID) {
    class $ {
      constructor(dispatcher, pipe) {
        pipe = pipe === VOID ? Companion_instance : pipe;
        this.c2f_1 = dispatcher;
        this.d2f_1 = pipe;
      }
      *b2f(action, $completion) {
        return yield* this.d2f_1.e2f(this.c2f_1, action, $completion);
      }
      toString() {
        return 'DispatcherPipeCannon(dispatcher=' + toString(this.c2f_1) + ', pipe=' + toString_0(this.d2f_1) + ')';
      }
      hashCode() {
        var result = this.c2f_1 == null ? 0 : hashCode(this.c2f_1);
        result = imul(result, 31) + hashCode(this.d2f_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DispatcherPipeCannon()))
          return false;
        if (!equals(this.c2f_1, other.c2f_1))
          return false;
        if (!equals(this.d2f_1, other.d2f_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DispatcherPipeCannon', VOID, VOID, [ActionCannon()], [1]);
    DispatcherPipeCannonClass = $;
  }
  return DispatcherPipeCannonClass;
}
//region block: exports
export {
  ActionCannon as ActionCannon17qqlawtblrps,
  DispatcherPipeCannon as DispatcherPipeCannon3aitdk4bdtfxf,
};
//endregion

//# sourceMappingURL=ActionCannon.mjs.map
